export default __webpack_public_path__ + "static/media/Boots of the Dark Messenger.d6e97a6f.jpg";